import * as React from "react";
const SvgAlertrSim = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-2e38fdda-98eb-4c2f-a74f-2903bc6a4eba", "data-name": "AlertrSIM", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2 13", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m0,0h2v9H0V0Z", style: {
  fill: "#de3c46"
} }), /* @__PURE__ */ React.createElement("path", { d: "m0,11h2v2H0v-2Z", style: {
  fill: "#de3c46"
} }));
export default SvgAlertrSim;
